import {
  EuiAccordion,
  EuiButtonIcon,
  EuiFieldText,
  EuiFlexGroup,
  EuiFlexItem,
  EuiForm,
  EuiFormRow,
  EuiIcon,
  EuiText,
  EuiTextColor,
  EuiTitle,
} from "@elastic/eui";
import { useAnketaI18n } from "src/internationalization";
import { useEffect, useState } from "react";
import { CreateNewUsersProps } from "src/questionnaires/types";

export const CreateNewUser = ({
  email,
  firstName,
  lastName,
  removeNewUser,
  updateNewUsers,
  organizations,
}: CreateNewUsersProps): JSX.Element => {
  const { translate } = useAnketaI18n();

  const [surname, setSurname] = useState<string>(firstName);
  const [lastname, setLastname] = useState<string>(lastName);

  useEffect(() => {
    if (updateNewUsers !== undefined) {
      updateNewUsers({
        email: email,
        firstName: surname,
        lastName: lastname,
        organizations,
      });
    }
  }, [surname, lastname]);

  const buttonContent = (
    <div>
      <EuiFlexGroup gutterSize="s" alignItems="center" responsive={false}>
        <EuiFlexItem grow={false}>
          <EuiIcon type="user" size="m" />
        </EuiFlexItem>

        <EuiFlexItem>
          <EuiTitle size="xs">
            <h3>{email}</h3>
          </EuiTitle>
          <p>{translate("anketa.user")}</p>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiText size="s">
        <p>
          <EuiTextColor color="subdued">
            {translate("anketa.user.new")}
          </EuiTextColor>
        </p>
      </EuiText>
    </div>
  );

  const extraAction = (
    <EuiButtonIcon
      iconType="cross"
      color="danger"
      className="EuiAccordionForm__extraAction"
      aria-label="Delete"
      onClick={() => {
        removeNewUser({
          email: email,
          firstName: surname,
          lastName: lastname,
          organizations,
        });
      }}
    />
  );

  return (
    <EuiForm>
      <EuiFormRow>
        <EuiAccordion
          id="accordionForm1"
          className="EuiAccordionForm"
          buttonClassName="EuiAccordionForm__button"
          buttonContent={buttonContent}
          extraAction={removeNewUser !== undefined && extraAction}
          paddingSize="l"
        >
          <EuiForm>
            <EuiFormRow
              label={translate("anketa.user.surname")}
              helpText={translate("anketa.required")}
            >
              <EuiFieldText
                icon="user"
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
              />
            </EuiFormRow>
            <EuiFormRow
              label={translate("anketa.user.lastname")}
              helpText={translate("anketa.required")}
            >
              <EuiFieldText
                icon="user"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
              />
            </EuiFormRow>
            <EuiFormRow label={translate("anketa.organization")}>
              <EuiFieldText readOnly value={organizations} />
            </EuiFormRow>
          </EuiForm>
        </EuiAccordion>
      </EuiFormRow>
    </EuiForm>
  );
};
